
<template>
  <div
    class="noti"
    v-if="show"
  >
    <span class="noti-arrow-out"></span>
    <span class="noti-arrow-int"></span>
    <div>
      <div
        v-if="ordernoti"
        class="noti-order"
        @click="routeToPath('/customer/orders')"
      >
        尚有未完成訂單
      </div>
      <div class="noti-message">
        <div class="noti-title">通知</div>
        <div
          class="list-group mb-1"
          v-if="messages && messages.length"
        >
          <div
            class="list-group-item ist-group-item-action px-0"
            v-for="(msg, msgIdx) in messages"
            :key="msgIdx"
            @click="routeToPath(msg.url)"
          >
            <span class="text-basic-gray">{{ msg.time | moment("YYYY.MM.DD HH:mm:ss")}}</span><br>
            <span>{{msg.content}}</span>
          </div>
        </div>
        <div v-else>尚無通知</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'notification',
  props: ['ordernoti', 'messages', 'show'],
  methods: {
    routeToPath (path) {
      if (path) {
        this.$emit('route', path)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/_variables.scss";

.noti {
  position: absolute;
  width: 100vw;
  max-width: 15rem;
  border-radius: 0.5rem;
  padding: 0.5rem;
  box-shadow: 0 1px 3px 2px rgba(0, 0, 0, 0.3);
  border: solid 1px $gray;
  background-color: white;
  color: $basic-black;
  text-align: center;
  font-size: 0.8rem;
  white-space: nowrap;
  &-arrow-int {
    position: absolute;
    border-width: 0.5rem;
    border-style: solid;
    border-color: transparent transparent white transparent;
    top: calc(-1rem + 1px);
    right: 0.2rem;
  }
  &-arrow-out {
    position: absolute;
    border-width: 0.5rem;
    border-style: solid;
    border-color: transparent transparent $gray transparent;
    top: calc(-1rem);
    right: 0.2rem;
  }
  &-order {
    background-color: $papayum_orange;
    color: $basic-white;
    border-radius: 1rem;
    margin-bottom: 0.5rem;
    padding: 0.5rem 0;
  }
  &-message {
    display: flex;
    flex-direction: column;
    height: 15rem;
    white-space: pre-wrap;
    overflow-y: scroll;
  }
  &-title {
    display: inline;
    margin: 0.5rem 0;
    font-size: 1.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/customer/Notification.vue